export default __webpack_public_path__ + "static/15-062771dc8f28f698edc9e9b9184f5517.jpg";